if (typeof JW === 'undefined') JW = {};
JW.BtnTgl = function ($, inp)
{
    var _pri = {};
    var publ = {};

    _pri.cname = 'BTNTGL';
    _pri.opts = {
        dbg_lvl:    1,
        defs: {

        }
    };

    _pri.inited = false;
    _pri.$inp   = null;
    _pri.$btn   = null;
    _pri.$icon  = null;
    _pri.domid  = '';

    _pri.extend = function()
    {
        JW.ExtCommon(jQuery, publ, _pri);
    };

    _pri.init = function()
    {
        _pri.dbgG('*** init()');

        if (_pri.inited)
        {
            return;
        }

        _pri.inited = true;
        _pri.page = JW.Page;

        _pri.$inp = $(inp);
        if (_pri.$inp.length != 1)
        {
            _pri.dbg('!!! inp not found! - return.');
            return;
        }

        _pri.$inp.css('display', 'none');

        _pri.initOpts();

        _pri.domid = 'wrp_' + _pri.$inp.attr('name') + '_' + _pri.page.getUId(8);
        _pri.$inp.wrap('<div id="' + _pri.domid + '" class="d-flex align-items-center cup text-left text-sm-center border-0 btn-toggel" role="button" tabindex="0" aria-pressed="false" title=""><i class="fa fa-2x text-secondary fa-rotate-180 fa-toggle-on mr-2" aria-hidden="true"></i><label class="' + _pri.opts.label_cls + '" for="' + _pri.$inp.attr('id') + '">' + _pri.opts.label + '</label></div>');

        _pri.$btn  = $('#' + _pri.domid);
        _pri.$icon = _pri.$btn.find('i.fa');

        _pri.$btn.on('click keyenter keyspace', _pri.onClick);
        _pri.$inp.on('change', _pri.onInpChange);

        _pri.setIcon();



        _pri.$inp.data('btn_tgl', publ);
    };

    _pri.onClick = function(e)
    {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();

        _pri.dbg('*** onClick()');

        _pri.$inp.prop('checked', !_pri.$inp.prop('checked')).trigger('change');
        _pri.page.trigger('btn_tgl:click', {name: _pri.$inp.attr('name'), state: _pri.$inp.prop('checked')});
    };

    _pri.onInpChange = function(e)
    {
        _pri.dbg('*** onChange()');
        _pri.setIcon();
    };

    _pri.setIcon = function()
    {
        if (_pri.$inp.prop('checked'))
        {
            _pri.$icon.removeClass('text-secondary fa-rotate-180');
            _pri.$icon.addClass('text-primary');
            _pri.$btn.prop('title', 'Abschalten: ' + _pri.opts.label);
            _pri.$btn.attr('aria-pressed', 'true');
        }
        else
        {
            _pri.$icon.removeClass('text-primary');
            _pri.$icon.addClass('text-secondary fa-rotate-180');
            _pri.$btn.prop('title', 'Einschalten: ' + _pri.opts.label);
            _pri.$btn.attr('aria-pressed', 'false');
        }
    };

    _pri.initOpts = function()
    {
        _pri.opts.label     = _pri.$inp.data('label') || '';
        _pri.opts.label_cls = _pri.$inp.data('label_cls') || 'h5';
    };

    _pri.extend();
    _pri.init();

    return publ;
};
